<script setup>
// documents/upload
// общий список документов для отправки по категориям заемщиков
import {ref, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import axios from "axios";
//----------------------------------------------------------------------
const store = useStore()
const docs = ref([])
const history = ref([])
onMounted( ()=>{
  init()
})

const init = async () => {
  store.commit('menuModule/initMenu')
  let urlDocs = process.env.VUE_APP_API + 'upload-docs.php'
  let urlDocs2 = process.env.VUE_APP_API + 'docs-history.php'
  await axios
      .get(`${urlDocs}?token=${token.value}`)
      .then(response => (docs.value = response.data))
      .then(
          await axios
              .get(`${urlDocs2}?token=${token.value}&id=${userId.value}`)
              .then(response => (history.value = response.data))
      )
      .catch(error => alert(error));

  // сохранить структуру в store, чтобы не делать запрос на странице с историей документа
  store.commit('docsModule/setDocuments', docs.value)
}

const isUpload = (section) => {
  // найти документ с номером section в history
  let index = history.value.findIndex(item => item.section === section)
  if (index >= 0){
    if (+history.value[index]['status'] === 1){
      return 'doc-upload'
    } else if (+history.value[index]['status'] === 2){
      return 'doc-upload-ok'
    } else if (+history.value[index]['status'] === 3){
      return 'doc-upload-rejected'
    }
  }
  return 'doc'
}

/*
const statusDoc = (section) => {
  // найти документ с номером section в history
  let index = history.value.findIndex(item => item.section === section)
  if (index >= 0){
    return history.value[index]['status']
  }
  return 0
}
*/

//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const userId = computed( () => {return store.getters['authModule/userId']})
</script>

<template>
  <main class="content-wrapper">

    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h3>Мои документы</h3>
            <p>Отправьте в СПБ ЦДЖ документы, заверенные электронной цифровой подписью, в соответствии с выбранным типом заёмщика.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card mb-4" v-for="(doc,index) in docs" :key="index">
              <div class="card-header header-bg">
                <h5 class="mt-1">{{ index+1 }}. {{ doc.section }}</h5>
              </div>
              <div class="card-body">
                <div v-for="(item,index) in doc.list" :key="index">
                    <h6 class="mt-3 mb-3 p-2"><strong>{{ item.type }}</strong></h6>
                    <div v-for="(d,index) in item.docs" :key="index"
                        :class="isUpload(d[1])"
                    >
                      <router-link :to="'/document/' + d[1] + '/history'" class="black-link">
                        <h6>{{ d[0] }}</h6>
                      </router-link>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
      </div>
    </section>
  </main>
</template>

<style scoped>
.doc{
  background-image:url(//personal.gorcenter.spb.ru/images/doc.svg);
  background-repeat:no-repeat;
  background-position: 0% 50%;
  background-size: 50px;
  padding:28px 0 20px 70px;
}
.doc-upload{
  background-image:url(//personal.gorcenter.spb.ru/images/doc-upload.svg);
  background-repeat:no-repeat;
  background-position: 0% 50%;
  background-size: 50px;
  padding:28px 0 20px 70px;
}
.doc-upload-ok{
  background-image:url(//personal.gorcenter.spb.ru/images/doc-ok.svg);
  background-repeat:no-repeat;
  background-position: 0% 50%;
  background-size: 50px;
  padding:28px 0 20px 70px;
}
.doc-upload-rejected{
  background-image:url(//personal.gorcenter.spb.ru/images/doc-rejected.svg);
  background-repeat:no-repeat;
  background-position: 0% 50%;
  background-size: 50px;
  padding:28px 0 20px 70px;
}
.header-bg{
  background-color: #80b5d3;
  color: #fff;
}
</style>